import { TeamSettingsAdminSlack } from "#webapp/src/components/teams-settings/team-settings-admin-form/team-settings-admin-slack";
import React from "react";
import { TeamSections } from "../web-settings";

type Props = {
  teamId: string;
};

export const TeamSlack = ({ teamId }: Props) => {
  return (
    <div cw-id={`web-settings-${TeamSections.Slack}`} className="cw-mb-7">
      <div className="cw-heading-xl cw-mb-4">Connect team availability calendar with Slack?</div>
      <div className="cw-body-lg cw-mb-6">
        Clockwise can send a daily summary of events on the team availability calendar to your
        selected Slack channel.
      </div>
      <TeamSettingsAdminSlack teamId={teamId} />
    </div>
  );
};
